import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  useAlerts,
  usePlanningActions,
  SUB_ORGANIZATION,
  REGISTRATIONS,
  SUB_EYE_DOCTOR,
  SUB_GP,
  SUB_FORM,
  SUB_TEAM_MEMBERS,
  SUB_PATIENT,
  SUB_EXAMINATION,
  EXPAND,
  META,
  EDITOR,
  CANCELLATIONS,
  SORT_BY,
  SORT_DIR,
  FILE,
} from 'store/planning';
import FileDropZone from 'components/FileDropZone';
import Message from 'components/Message';

import { Container } from './styles';

const AppendPatients = ({ sort, disabled }) => {
  const { appendPatientsToRegistration } = usePlanningActions();
  const { action, loading, success, error } = useAlerts(appendPatientsToRegistration);
  const onDrop = useCallback(
    (files) => {
      if (files[0])
        action({
          [FILE]: files[0],
          [EXPAND]: [
            SUB_ORGANIZATION,
            `${META}.${EDITOR}`,
            `${REGISTRATIONS}.${SUB_PATIENT}`,
            `${REGISTRATIONS}.${SUB_ORGANIZATION}`,
            `${REGISTRATIONS}.${SUB_EYE_DOCTOR}`,
            `${REGISTRATIONS}.${SUB_GP}`,
            `${REGISTRATIONS}.${SUB_EXAMINATION}`,
            `${REGISTRATIONS}.${SUB_FORM}`,
            SUB_TEAM_MEMBERS,
            `${CANCELLATIONS}.${SUB_PATIENT}`,
          ],
          ...sort,
        });
    },
    [action, sort]
  );

  return (
    <Container>
      <FileDropZone
        onDrop={onDrop}
        accept={['application/pdf']}
        disabled={disabled}
        loading={loading}
        label="Einverständniserklärungen in dieses"
        acceptFormats={['.pdf']}
      />
      {error && (
        <Message type="error" small={1} form={1} textAlign="right">
          {error}
        </Message>
      )}
      {success && (
        <Message type="success" small={1} form={1} textAlign="right">
          Terminplan erfolgreich aktualisiert
        </Message>
      )}
    </Container>
  );
};

AppendPatients.defaultProps = { disabled: false };
AppendPatients.propTypes = {
  sort: PropTypes.shape({
    [SORT_BY]: PropTypes.string.isRequired,
    [SORT_DIR]: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
};

export default AppendPatients;
